export { InventoryHistory } from "./inventoryHistory";
